//  Copyright (c) 2025 coze-dev
//  SPDX-License-Identifier: MIT

export * from '@coze-editor/code-language-json';
